import React, { Component } from 'react';
import { ButtonType } from '../Button/Button.props';
import OverlayButtonProps from './OverlayButton.props';
import OverlayButtonState from './OverlayButton.state';

export default class OverlayButton extends Component<OverlayButtonProps, OverlayButtonState> {
    private closeButton: React.RefObject<HTMLButtonElement>;
    private buttonOverlayElement: React.RefObject<HTMLDivElement>;

    public get clickstatus(): unknown {
        return this.closeButton.current?.click();
    }

    constructor(props: OverlayButtonProps) {
        super(props);
        this.state = {
            visible: false
        };

        this.closeButton = React.createRef<HTMLButtonElement>();
        this.buttonOverlayElement = React.createRef<HTMLDivElement>();
        this.closeOverlay = this.closeOverlay.bind(this);
    }

    componentDidMount() {
        try {
            this.buttonOverlayElement.current?.instance || window.Juris.moduleRegistry.applyModule('CtaOverlayButton', this.buttonOverlayElement.current);
        } catch (error) {
            console.log(error);
        }
    }

    closeOverlay() {
        this.props.closeButtonRef?.current?.click();
        this.closeButton.current?.click();
    }

    render(): React.ReactNode {
        return (
            <><div className="cta-overlay-button" data-testid="OverlayButton" ref={this.buttonOverlayElement}>
                <div className="cta-overlay-button__trigger">
                    {
                        this.props.label && (this.props.type === ButtonType.CTABUTTON
                            ? <>
                                <button className={this.props.buttonClass ? this.props.buttonClass : "cta-button cta-button--button-red"}
                                    type="button">{this.props.label}</button>
                            </> : <>
                                <button className={this.props.buttonClass ? this.props.buttonClass : "text-icon-link text-icon-link--button text-icon-link--edit"} type="button">
                                    <span className="text-icon-link__icon"></span>
                                    <span className="text-icon-link__text">{this.props.label}</span>
                                </button>
                            </>)
                    }
                </div>
                <div className="cta-overlay-button__container cta-overlay-button__container--below"
                    data-cta-overlay-button-open={this.state.visible}>
                    <div className="cta-overlay-button__body container">
                        <button className="cta-overlay-button__close-btn" type="button" ref={this.props.closeButtonRef || this.closeButton}>
                            <span className="cta-overlay-button__close-btn-icon"></span>
                        </button>
                        {this.props.children}
                    </div>
                </div>
                <div className="cta-overlay-button__backdrop"></div>
            </div></>
        );
    }
}
